/**
 * Mixin methods that handle vuex chat room actions (close, invite, leave ...)
 */

export default {
  name: 'mixin-chat-message-actions',
  methods: {
    fetchMessages ({ room, options }) {
      const reset = options?.reset || false
      this.reset = reset
      if (!this.singleRoom) {
        if (room && this.roomId !== room?.roomId) {
          this.$router.push({
            name: 'chats',
            params: {
              roomType: this.getCurrentRoomTypeForUrl(room?.roomType),
              roomId: room?.roomId
            }
          })
        }
      }
      if (this.roomId && room) {
        if (reset && (!room.archived && room.isMember) && room.unreadCount > 0) {
          this.setRoomAsRead(this.roomId)
        }
        // realtime api, mixing chat/realtime
        this.onOpenRoom(room, reset)
      }
    },

    sendMessage ({ content, roomId, files, replyMessage }) {
      const that = this
      let messageIndex
      const newMessage = {
        _id: Math.floor(Math.random() * 100),
        content: content,
        roomId: roomId,
        senderId: this.currentUser.username,
        timestamp: this.formatTime(new Date()),
        date: this.formatDate(new Date()),
        distributed: false,
        deleted: false,
        disableActions: true,
        disableReactions: true
      }
      if (files?.length > 0) {
        const filesMapped = files.map(function (file) {
          return {
            name: '',
            size: file.size,
            type: file.type,
            audio: that.isAudio(file.type),
            image: that.isImage(file.type),
            url: file.localUrl,
            blob: file.blob
          }
        })
        newMessage.files = filesMapped
        this.messages = [...this.messages, newMessage]
        messageIndex = this.messages.length
        // rest api, mixing chat/rest
        this.uploadMessageFiles(newMessage, replyMessage)
      } else {
        this.messages = [...this.messages, newMessage]
        messageIndex = this.messages.length
        // realtime api, mixing chat/realtime
        this.sendChatMessage(this.roomId, newMessage.content, replyMessage)
      }
      // handle errors
      setTimeout(() => {
        if (!this.messages[messageIndex - 1].distributed) {
          this.messages[messageIndex - 1]._id = `failed_${this.messages[messageIndex - 1]._id}`
          this.messages[messageIndex - 1].failure = true
          this.messages[messageIndex - 1].seen = false
        }
      }, 9000) // wait 9s
    },

    setMessageReaction ({ reaction, remove, messageId, roomId }) {
      this.sendMessageReaction(reaction, messageId, remove)
    },

    typing: function ({ room, options }) {
      this.sendTypingEvent()
    },

    editMessage ({ messageId, newContent, roomId, files }) {
      const rocketMessage = this.rocketMessages.find(message => message._id === messageId)
      const messageIndex = this.findMessageIndexById(messageId)
      if (messageIndex >= 0) {
        this.messages[messageIndex].content = newContent
        rocketMessage.msg = newContent
        if (rocketMessage) {
          this.rapiUpdateMessage(rocketMessage)
        }
      }
    },

    deleteMessage ({ message, roomId }) {
      const messageIndex = this.findMessageIndexById(message._id)
      if (messageIndex >= 0) {
        this.messages[messageIndex].deleted = true
        this.rapiDeleteMessage(message._id)
        setTimeout(() => {
          this.messages.splice(messageIndex, 1)
        }, 1000)
      }
    }
  }
}
